import { commonApi } from '@common/utils/baseQuery';
import { ISendClientInfoPayload } from '@common/utils/detectClient/deviceInfo.type';
import config from '@config';
import { IUser, IUserCredentials, IUserGeolocation } from '@features/auth/api/authApi.type';

export const authApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<IUser, IUserCredentials>({
      query: (credentials) => ({
        url: '/auth/login',
        body: credentials,
        method: 'POST',
      }),
    }),
    checkToken: builder.query<IUser, void>({
      query: () => '/auth/me',
      // @ts-expect-error
      providesTags: [ 'Auth' ],
    }),
    updateUserGeolocation: builder.mutation<void, IUserGeolocation>({
      query: (data) => ({
        url: `${config.gpsTracker}/gps/users/add`,
        body: data,
        method: 'POST',
      }),
    }),
    sendClientInfo: builder.mutation<{ status: number, message: string }, ISendClientInfoPayload>({
      query: (data) => ({
        url: `${config.clientInfoHost}/device-info/apply`,
        body: data,
        method: 'POST',
      }),
    }),

  }),
});

export const {
  useLoginMutation,
  useCheckTokenQuery,
  useUpdateUserGeolocationMutation,
  useSendClientInfoMutation
} = authApi;
